import { render, staticRenderFns } from "./flowRequirementRelateAuditForm.vue?vue&type=template&id=0a6c0c21&"
import script from "./flowRequirementRelateAuditForm.vue?vue&type=script&lang=js&"
export * from "./flowRequirementRelateAuditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports